module.exports = __webpack_public_path__ + "static/media/learn-illustration.e8b4fc1e.png";